<template>
  <div class="text" v-html="config.text"></div>
</template>

<script>
export default {
  props: ["config"],
  data() {
    return {};
  },
  mounted() {},
  methods: {

  }
};
</script>

<style scoped>
h1 {
  text-align: center;
}
.text {
  padding: 0px 20px;
  color: #111;
  font-weight: 400;
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/cms/pageComponents/TextComponent.vue